/* eslint-disable no-unused-vars */
export enum FlagStates {
  Loaded = 'loaded',
  Loading = 'loading',
  Error = 'error',
}
